import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
import getBrowserLocale from "@/util/i18n/get-browser-locale"
import { supportedLocalesInclude } from "./util/i18n/supported-locales"
import {
  getChoiceIndex,
  setDefaultChoiceIndexGet
} from "./util/i18n/choice-index-for-plural"
Vue.use(VueI18n)
 
function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getStartingLocale() {
  var url = new URL(window.location.href);
  var url_string = url.search;
  var LangToLoad = url.searchParams.get('language');
  
  if(LangToLoad != undefined){
    if((LangToLoad=='MS')||(LangToLoad=='ms')){
      LangToLoad = 'bm'
    }
    const browserLocale = LangToLoad.toLowerCase();
    store.state.Login.LanguageToLoad = LangToLoad.toLowerCase();
    if (supportedLocalesInclude(browserLocale)) {
      return browserLocale
    } else {
      return process.env.VUE_APP_I18N_LOCALE || "en"
    }
  }else{
    if(store.state.LanguageToLoad != undefined){
      if((store.state.LanguageToLoad=='MS')||(store.state.LanguageToLoad=='ms')){
        LangToLoad = 'bm'
      }

      if((store.state.LanguageToLoad=='EN')||(store.state.LanguageToLoad=='en')){
        LangToLoad = 'EN'
      }
      const browserLocale = LangToLoad.toLowerCase();
      store.state.Login.LanguageToLoad = LangToLoad.toLowerCase();
      if (supportedLocalesInclude(browserLocale)) {
        return browserLocale
      } else {
        return process.env.VUE_APP_I18N_LOCALE || "en"
      }
    }else{
      console.log(store.state.LanguageToLoad)
      const browserLocale = store.state.LanguageToLoad
      
      if (supportedLocalesInclude(browserLocale)) {
        return browserLocale
      } else {
        return process.env.VUE_APP_I18N_LOCALE || "en"
      }
    }
   
  }
  
  //store.state.LanguageToLoad
  // getBrowserLocale({ countryCodeOnly: true })

}


setDefaultChoiceIndexGet(VueI18n.prototype.getChoiceIndex)

VueI18n.prototype.getChoiceIndex = getChoiceIndex


export default new VueI18n({

  locale: getStartingLocale(),
  //locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
 
})
